import { EntityDetailViewProps } from "../../common/entity/EntityInterfaces";
import { EntityDetailPage, EntityDetailView } from "../../common/entity/EntityDetailPage";
import { CustomImportLogsTable } from "./Table/CustomImportLogsTable";
import { EntityTablePage } from "../../common/entity/EntityTablePage";
import { CustomImportLogsDetail } from "./CustomImportLogsDetail";

// Detail
export const CustomImportLogsDetailView = ({ id }: EntityDetailViewProps<"customImportLogs">) => {
  return (
    <EntityDetailView id={id} entityTypeId={"customImportLogs"} filters={{}}>
      {(props) => <CustomImportLogsDetail {...props} />}
    </EntityDetailView>
  );
};

export const CustomImportLogDetailsPage = () => {
  return (
    <EntityDetailPage<"customImportLogs"> isIntId>{(id) => <CustomImportLogsDetailView id={id} />}</EntityDetailPage>
  );
};

export const CustomImportLogsTablePage = () => {
  return (
    <EntityTablePage entityTypeId={"customImportLogs"}>
      {(props) => <CustomImportLogsTable {...props} />}
    </EntityTablePage>
  );
};
